module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Complete-Profile-87b09470599c3ef77d65b5b1386f6656.svg";